<template>
  <div class="flex flex-col items-center">
    <TeCommonBalloon
      v-if="showNotification == 'today'"
      class="mb-5 inline-block rounded border-co-danger-500 bg-co-danger-500 px-9 py-2 text-white"
    >
      <div class="flex items-center">
        <img
          class="mr-1"
          src="~/assets/images/Te/TeTop/Deadline/icon-flame.svg"
          loading="lazy"
          width="15"
          height="20"
        >
        本日締切
      </div>
    </TeCommonBalloon>
    <TeCommonBalloon
      v-if="showNotification == 'aLittleLeft'"
      class="mb-5 inline-block rounded border-co-danger-500 bg-co-danger-500 px-9 py-2 text-white"
    >
      <div class="flex items-center">
        <img
          class="mr-1"
          src="~/assets/images/Te/TeTop/Deadline/icon-flame.svg"
          loading="lazy"
          width="15"
          height="20"
        >
        残りわずか
      </div>
    </TeCommonBalloon>
    <div class="co-display-13 mx-auto mb-5 inline-block bg-co-gray-300 p-2 px-[3.75rem]">
      申込締切
      <span class="co-display-8 px-1 font-bold">{{ month }}</span>月<span class="co-display-8 px-1 font-bold">{{ day }}</span>日<span class="px-1">（{{ dayOfWeek }}）</span><span class="co-display-8 px-1 font-bold">{{ hours }}</span>時
    </div>
  </div>
</template>

<script lang="ts">
import { formatDayOfWeek } from '~/utility/utility'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'

const options = {
  props: {
    cohort: {
      type: Object,
      default: null,
    },
  },
  computed: {
    closesAt() {
      return this.cohort ? new Date(this.cohort.attributes.closes_at) : null
    },
    yesterdayClosesAt() {
      if (this.closesAt) {
        const yesterday = new Date(this.closesAt)
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday
      } else {
        return null
      }
    },
    hours() {
      return this.closesAt ? this.closesAt.getHours() + 24 : '-'
    },
    day() {
      return this.closesAt ? this.yesterdayClosesAt.getDate() : '-'
    },
    month() {
      return this.closesAt ? this.yesterdayClosesAt.getMonth() + 1 : '-'
    },
    dayOfWeek() {
      if (this.closesAt) {
        const dayOfWeek = formatDayOfWeek(this.yesterdayClosesAt, false)
        return dayOfWeek
      } else {
        return '-'
      }
    },
    showNotification() {
      if (this.closesAt) {
        const now = new Date()
        const leftDays = (this.closesAt - now) / (1000 * 60 * 60 * 24)
        if (leftDays > 0 && leftDays < 1) {
          return 'today'
        } else if (leftDays > 1 && leftDays < 3) {
          return 'aLittleLeft'
        } else {
          return null
        }
      } else {
        return null
      }
    },
  },
  components: {
    TeCommonBalloon,
  },
}

export default defineNuxtComponent(options)
</script>
